import {FC, useEffect} from 'react';
import AurPopup from '../aur-popup/AurPopup';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {t} from 'i18next';
import {
  setHasUnsavedChanges,
  setShowModal,
} from '../../../redux/slices/unSaveChangesModalSlice';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import {setSelectedClient} from '../../../redux/slices/bulkUserFileNameSlice';
import {UrlPathEnums} from '../../../utils/enumUtils';
import {useAnalytics} from '../../../hooks/useAnalytics';
import {
  GA_EVENT_NAMES,
  GA_CLICK_TYPES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../constants/analyticsConstants';

const UnsavedChangesModal: FC = () => {
  const dispatch = useDispatch();
  const {trackGAEvent} = useAnalytics();
  const showModal = useSelector(
    (state: RootState) => state.unsavedChangesModal.showModal
  );

  const navigate = useNavigate();

  useEffect(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name: t('gaTracking.users.startOverModal'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  }, []);

  const navigateToBulkUploadScreen = () => {
    navigate(UrlPathEnums.UsersBulkUploadAdd);
    dispatch(setShowModal(false));
    localStorage.setItem('currentPath', '');
    dispatch(setSelectedClient(''));
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.users.startOver'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.users.startOverOkAction'),
      },
      subPage: {
        subpage_name: t('gaTracking.users.startOverModal'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  };

  const closeModalHandler = () => {
    dispatch(setShowModal(false));
    dispatch(setHasUnsavedChanges(true));
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.users.cancel'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.users.startOverCancelAction'),
      },
      subPage: {
        subpage_name: t('gaTracking.users.startOverModal'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  };

  return (
    <Box className="aur-unsaved-modal">
      <AurPopup
        aria-label={t('common.cancelUploadPopup.ariaLable')}
        aria-description={t('common.cancelUploadPopup.ariaDescription')}
        className="inactivity-popup-modal"
        open={showModal}
        onOk={navigateToBulkUploadScreen}
        onCancel={closeModalHandler}
        popupHeading={t('common.unSavedChangesPopup.heading')}
        showCloseIcon={true}
        showPopupTitle={true}
        showPopupHeading={true}
        popupContent={t('common.unSavedChangesPopup.content')}
        popupTitle={t('common.unSavedChangesPopup.title')}
        labelActionCancel={t('common.unSavedChangesPopup.cancelBtn')}
        labelActionOk={t('common.unSavedChangesPopup.bulkUploadBtn')}
      />
    </Box>
  );
};

export default UnsavedChangesModal;
